module.exports = __webpack_public_path__ + "media/images/emblems/Steffisburg-coat_of_arms-477226c65c708c4b45410d21bc43c910.svg";